import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Navigation from './navigation'
import Topbar from './topbar'

// TODO: move this elsewhere
const StyledPage = styled.div`
    width:100%;
    min-height:100vh;
    height:${({autoHeight})=> autoHeight ? 'auto' : '100px'};
    display:flex;
    flex-direction:column;
    padding-top:80px;
`
const PageContent = styled.div`
    display:${({autoHeight})=> autoHeight ? 'block' :'flex'};
    flex-direction:column;
    flex:1 1 auto;
    margin: 0 auto;
    width:100%;
    padding-top:${({container})=>container ?  '40px' : '0'};
    max-width:${({container})=>container ?  '1280px' : '100%'};
`


/*
    
*/
export default class Page extends PureComponent{
    render(){
        let {title,container, autoHeight} = this.props
        let className = 'page'
        className+= this.props.className ? this.porps.className : ''
        return (<StyledPage className={className}>
            <Topbar title={title}>
                <Navigation {...this.props} />
            </Topbar>
            <PageContent autoHeight={autoHeight} container={container}>
                {this.props.children}
            </PageContent>
        </StyledPage>)
    }
}

Page.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
}


// WEBPACK FOOTER //
// ./src/components/app/page.js